import * as React from 'react';
import { classes } from './CalendarsInfoPopover.st.css';
var InfoIcon = function (_a) {
    var isMobile = _a.isMobile;
    var width = isMobile ? '28' : '32';
    var height = isMobile ? '28' : '32';
    return (React.createElement("svg", { imageRendering: "optimizeQuality", width: width, height: height, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { className: classes.c1, cx: "15.5", cy: "15.5", r: "10", stroke: "black" }),
        React.createElement("line", { className: classes.c1, x1: "16", y1: "12.875", x2: "16", y2: "19.875", stroke: "black" }),
        React.createElement("line", { className: classes.c1, x1: "16", y1: "11.125", x2: "16", y2: "12", stroke: "black" })));
};
export default InfoIcon;
//# sourceMappingURL=InfoIcon.js.map